import { configurePlayerPreRollAds } from '../utils/brightcove-ad-targeting';

const onReady =
	typeof window !== 'undefined' &&
	window.hmUtils &&
	typeof window.hmUtils.onDomContentLoad === 'function'
		? window.hmUtils.onDomContentLoad
		: function ( callback ) {
			if ( document.readyState === 'loading' ) {
				document.addEventListener( 'DOMContentLoaded', callback );
			} else {
				callback();
			}
		  };

const initPipVideoPlayers = function () {
	if ( typeof window === 'undefined' || typeof document === 'undefined' ) {
		return;
	}

	window.dataLayer = window.dataLayer || [];

	const candidateElements = document.querySelectorAll(
		'.vjs-pip-container video-js, video-js#hmBrightcove',
	);
	const playerElements = Array.from( candidateElements ).filter( ( el ) => {
		const isDiscussion =
			el.closest( '.vjs-discussion-container' ) ||
			el.hasAttribute( 'data-autoadvance' ) ||
			el.closest( '.vjs-pip-container' )?.querySelector( '.up-next' );
		return ! isDiscussion;
	} );

	playerElements.forEach( ( playerElement ) => {
		if ( typeof videojs !== 'undefined' && ! playerElement.dataset.hmPipPlayerInit ) {
			playerElement.dataset.hmPipPlayerInit = '1';
			const playerInstance = videojs( playerElement );
			configurePlayerPreRollAds( playerInstance, playerElement );

			playerInstance.ready( function () {
				const pipPlayer = this;
				configurePlayerPreRollAds( pipPlayer, playerElement );

				let playEventLogged = false;

				pipPlayer.on( 'playing', function () {

					const isAudio = playerElement.closest( '.wp-block-hm-brightcove-with-tracking' )?.classList.contains( 'is-audio' );
					const playerEvent = isAudio ? 'audio_start' : 'video_start';

					const videoTitle = pipPlayer.mediainfo?.name;
					const playerId = pipPlayer.bcinfo?.playerId;
					const videoId = pipPlayer.mediainfo?.id;

					if ( !playEventLogged ) {
						window.dataLayer.push({
							'event': playerEvent,
							'videoTitle': videoTitle,
							'playerId': playerId,
							'videoId': videoId
						} );
						playEventLogged = true;
					}
				} );
			} );
		}
	} );
};

if ( typeof document !== 'undefined' && document.readyState !== 'loading' ) {
	initPipVideoPlayers();
}
onReady( initPipVideoPlayers );